module.exports = __webpack_public_path__ + "static/media/brand-logo.6d4986cf.png";